<app-page-header class="assistant-header">
  <!-- LEFT -->
  <div class="header-left">
    <div class="header-brand">
      <div class="header-logo">
        <!-- <img src="assets/images/abc_logo.png" alt="Logo" /> -->
      </div>
    </div>
  </div>

  <!-- CENTER -->
  <div class="header-center">
    <div class="query-toggle" [class.mobile-toggle]="isBelowIpadSize">
      <!-- Private -->
      <label class="toggle-item" [class.active]="assistBotService.queryType['library']">
        <input type="radio" id="private" value="private" name="queryType"
          [checked]="assistBotService.queryType['library']" (change)="changeQuery($event)" />

        <span class="toggle-icon private-icon">
          <i class="pi pi-lock"></i>
        </span>

        <span class="toggle-content">
          <span class="toggle-text"> Private </span>

          <!-- <span class="toggle-description">
            Your documents
          </span> -->
        </span>
      </label>

      <!-- Generic -->
      <label class="toggle-item" [class.active]="!assistBotService.queryType['library']">
        <input type="radio" id="generic" value="generic" name="queryType"
          [checked]="!assistBotService.queryType['library']" (change)="changeQuery($event)" />

        <span class="toggle-icon generic-icon">
          <i class="pi pi-globe"></i>
        </span>

        <span class="toggle-content">
          <span class="toggle-text"> Generic </span>

          <!-- <span class="toggle-description">
            General knowledge
          </span> -->
        </span>
      </label>
    </div>
  </div>

  <!-- RIGHT -->
  <div class="header-right">
    <!-- Documents -->
    <div class="doc-dropdown-wrapper" #dropdownWrapper>
      <button type="button" class="document-action-btn" pTooltip="Documents" showDelay="700" hideDelay="200"
        tooltipPosition="bottom" tooltipStyleClass="small-tooltip" [class.active]="showDocumentDropdown"
        (click)="onClickDropdownDocumentList($event)">
        <span class="document-icon">
          <i class="pi pi-file"></i>
        </span>

        @if (electedDocuments?.length) {
        <span class="document-badge">
          {{ electedDocuments.length > 99 ? "99+" : electedDocuments.length }}
        </span>
        }
      </button>

      <!-- DOCUMENT DROPDOWN -->
      @if (showDocumentDropdown) {
      <div class="doc-dropdown">
        <!-- Dropdown Header -->
        <div class="dropdown-header">
          <div class="dropdown-title">
            <div class="dropdown-title-icon">
              <i class="pi pi-folder"></i>
            </div>
            <div>
              <h4>Documents</h4>
              <span> Your available documents </span>
            </div>
          </div>
          <span class="count">
            {{ electedDocuments.length }}
          </span>
        </div>
        <!-- Search -->
        <div class="search-box">
          <i class="pi pi-search"></i>
          <input type="text" placeholder="Search documents..." [(ngModel)]="searchDoc" (input)="filterDocuments()" />
          @if (searchDoc) {
          <button type="button" class="clear-search" (click)="searchDoc = ''; filterDocuments()">
            <i class="pi pi-times"></i>
          </button>
          }
        </div>
        <!-- Document List -->
        <div class="dropdown-body">
          @for (doc of filteredDocuments; track doc) {
          <div class="doc-item">
            <div class="doc-icon">
              <i class="pi pi-file-pdf"></i>
            </div>
            <div class="doc-content">
              <div class="doc-name" (click)="viewDocument(doc)">
                {{ doc.message }}
              </div>
              <!-- <span class="doc-type">
                  Document
                </span> -->
            </div>
            <button type="button" class="view-btn" pTooltip="View Document" tooltipPosition="left"
              tooltipStyleClass="small-tooltip" (click)="viewDocument(doc)">
              <i class="pi pi-eye"></i>
            </button>
          </div>
          }
          <!-- Empty State -->
          @if (!filteredDocuments?.length) {
          <div class="empty-documents">
            <div class="empty-icon">
              <i class="pi pi-folder-open"></i>
            </div>
            <strong>No documents found</strong>
            <span> Try a different search term </span>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <!-- New Conversation -->
    <!-- New Conversation -->
    <button type="button" class="header-action-btn new-conversation-btn" pTooltip="New Conversation" showDelay="700"
      hideDelay="200" tooltipPosition="bottom" tooltipStyleClass="small-tooltip" (click)="onClickStartConversation()">
      <span class="action-icon">
        <i class="pi pi-refresh"></i>
      </span>
    </button>

    <!-- History -->
    <button type="button" class="header-action-btn history-btn" pTooltip="History" showDelay="700" hideDelay="200"
      tooltipPosition="bottom" tooltipStyleClass="small-tooltip" (click)="toggleHistory()">
      <span class="action-icon">
        <i class="pi pi-history"></i>
      </span>
    </button>
  </div>
</app-page-header>

<!--Main chatgpt-->
<div class="main">
  @if(chatData?.length > 0) {
  <div #chatContainer class="chat-list msg-list-view" (scroll)="onScroll()">
    @if (selectedItem?.histories?.length > 0) {
    @for (
    item of selectedItem.histories;
    track trackByFn(i, item);
    let i = $index
    ) {
    <app-ai [data]="item" [index]="i" [historyItem]="selectedItem" [modelType]="assistBotService.queryType['library']"
      [documentIds]="selectedDoc_ids" [active]="item.history_id === activeHistoryId" [aiLoading]="aiLoading"
      (resubmitQuestion)="askAgain($event)" (historyCreated)="refreshConversation($event)">
    </app-ai>
    }
    } @else {
    <div class="empty-chat">
      No conversation history found
    </div>
    }
  </div>
  } @else {
  <div class="chat-wrapper scroll-bar">
    <div class="empty-state">
      <div class="has-text-centered box">
        <div class="welcome-banner">
          <div class="welcome-content">
            <h2>
              Hi <span [innerHTML]="isLoggedUser"></span>, welcome to
              <strong>Absence Law Assistance</strong>
            </h2>

            <p>
              I'll help you with questions about federal, state, and employer
              policies.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  }

  <div class="chat-input-wrapper">
    <div class="chat-input-container">
      <div class="input-area">
        <div #messageInput class="message-input" contenteditable="true" spellcheck="true"
          [attr.data-placeholder]="placeholderMsg" (keydown)="onEditorKeyDown($event)" (input)="onInput($event)"></div>
      </div>

      <div class="actions">
        @if (!activeVoiceOver) {

        <button class="icon-btn mic" (click)="startVoiceRecognition()" pTooltip="Mic" tooltipPosition="left"
          tooltipStyleClass="small-tooltip">
          <img src="assets/images/ai-agentic/mic.png" />
        </button>

        <button class="icon-btn call" (click)="startAIVoiceAgent()" pTooltip="Voice Agent" tooltipPosition="left"
          tooltipStyleClass="small-tooltip">
          <img src="assets/images/ai-agentic/agentic_ai.png" />
        </button>

        <button class="send-btn" [disabled]="!queryInputValue?.trim()" [class.active]="queryInputValue?.trim()"
          (click)="submitQuestion()" tooltipStyleClass="small-tooltip">
          <i class="pi pi-send"></i>
        </button>

        } @else {

        <button class="icon-btn stop" (click)="stopVoiceRecord()">
          <img src="assets/images/ai-agentic/close.png" />
        </button>

        <button class="send-btn" [disabled]="!queryInputValue?.trim()" [class.active]="queryInputValue?.trim()"
          (click)="submitQuestion()">
          <i class="pi pi-send"></i>
        </button>

        }
      </div>
    </div>

    <p class="input-hint">
      <i class="pi pi-info-circle"></i>
      Press <kbd>Enter</kbd> to send · <kbd>Shift + Enter</kbd> for new line
    </p>
  </div>
</div>
<!--end main chatgpt-->

<!-- Overlay -->
@if (isHistoryOpen) {
<div class="history-overlay" (click)="toggleHistory()"></div>
}

<!-- Right Panel -->
<div class="history-panel" [class.open]="isHistoryOpen">
  <!-- Header -->
  <div class="history-header">
    <h3>History</h3>

    <button class="close-btn" (click)="toggleHistory()">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <!-- Search -->
  <div class="history-search">
    <i class="pi pi-search"></i>

    <input type="text" placeholder="Search conversation..." [(ngModel)]="search" (keyup)="searchInList.next($event)" />
  </div>

  <!-- Scrollable Body -->
  <div class="history-body">
    <!-- PINNED -->
    @if (pinnedHistory?.length) {
    <div class="section-title">
      <i class="pi pi-thumbtack"></i>
      Pinned
    </div>
    @for (item of pinnedHistory; track trackByFn($index, item)) {
    <div class="history-item pinned-item" [class.active]="item.conversation_id === chatData?.conversation_id"
      (click)="onHistoryClick(item)">
      <div class="item-left">
        <div class="icon">
          <i class="pi pi-comment"></i>
        </div>
        <div class="content">
          <div class="title" [title]="item.question">
            {{ item.question }}
          </div>
        </div>
      </div>
      <div class="item-actions">
        <button class="action-btn pin" pTooltip="Un Pin"  tooltipPosition="left" (click)="pinItem(item); $event.stopPropagation()">
          <i class="pi pi-thumbtack"></i>
        </button>
        <button class="action-btn delete" pTooltip="Delete"  tooltipPosition="left" (click)="deleteHistory(item, $event)">
          <i class="pi pi-trash"></i>
        </button>
      </div>
    </div>
    } }

    <!-- RECENT -->
    <div class="section-title">
      <i class="pi pi-history"></i>
      Recent
    </div>

    @for (item of recentHistory; track trackByFn($index, item)) {
    <div class="history-item" [class.active]="item.conversation_id === chatData?.conversation_id"
      (click)="onHistoryClick(item)">
      <div class="item-left">
        <div class="icon">
          <i class="pi pi-comment"></i>
        </div>
        <div class="content">
          <div class="title" [title]="item.question">
            {{ item.question }}
          </div>
        </div>
      </div>
      <div class="item-actions">
        <button class="action-btn pin" pTooltip="Pin"  tooltipPosition="left"  (click)="pinItem(item); $event.stopPropagation()">
          <i class="pi pi-thumbtack"></i>
        </button>
        <button class="action-btn delete" pTooltip="Delete"  tooltipPosition="left" (click)="deleteHistory(item, $event)">
          <i class="pi pi-trash"></i>
        </button>
      </div>
    </div>
    }
  </div>
</div>

<!-- Document Popup -->

<p-dialog [(visible)]="showDocumentPopup" [modal]="true" [draggable]="false" [resizable]="false"
  [dismissableMask]="true" [style]="{ width: '92vw', height: '92vh' }"
  [contentStyle]="{ padding: '0', overflow: 'hidden' }" styleClass="document-viewer-dialog">
  <!-- Header -->
  <ng-template pTemplate="header">
    <div class="doc-header">
      <div class="doc-header-left">
        <div class="doc-icon">
          <i class="pi pi-file"></i>
        </div>

        <div class="doc-heading">
          <h3>{{ docViewHeading }}</h3>

          <span class="doc-meta">
            {{ electedDocuments.length }}
            {{ electedDocuments.length === 1 ? "document" : "documents" }}
          </span>
        </div>
      </div>

      <div class="doc-header-right">
        <div class="current-doc">
          <span>Document</span>
          <strong>
            {{ selectedDocumentIndex + 1 }}
            /
            {{ electedDocuments.length }}
          </strong>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Main Content -->
  <div class="document-container">
    <!-- Viewer -->
    <section class="viewer-section">
      <!-- Loading -->
      @if (documentLoading) {
      <div class="loader-container">
        <div class="loader-icon">
          <i class="pi pi-spin pi-spinner"></i>
        </div>
        <h4>Loading document</h4>
        <p>Please wait while the document is being loaded...</p>
      </div>
      }

      <!-- Video / Audio -->
      @if ( isSelectFileType === 'video' || isSelectFileType === 'audio') {
      <div class="media-viewer">
        <vg-player>
          <vg-overlay-play></vg-overlay-play>
          <vg-buffering></vg-buffering>
          <vg-scrub-bar>
            <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
            <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
            <div id="video-controls">
              <div id="seek-bar-container">
                <div id="seek-bar">
                  <div id="current-time">
                    @for (percent of markerSeekBar; track percent) {
                    <div class="bubles" [ngStyle]="{ left: percent }"></div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </vg-scrub-bar>
          <vg-controls [vgAutohide]="true" [vgAutohideTime]="2">
            <vg-play-pause></vg-play-pause>
            <vg-time-display vgProperty="current" vgFormat="mm:ss">
            </vg-time-display>
            <span class="time-divider">/</span>
            <vg-time-display vgProperty="total" vgFormat="mm:ss">
            </vg-time-display>
            <vg-scrub-bar class="control-spacer" style="pointer-events: none">
            </vg-scrub-bar>
            <vg-mute></vg-mute>
            <vg-volume></vg-volume>
            <vg-fullscreen></vg-fullscreen>
          </vg-controls>
          <video #media [vgMedia]="media" id="singleVideo" crossorigin
            (timeupdate)="getVideoPlayingOnTime($event.target.currentTime)">
            <source [src]="selectedReadFile" type="video/mp4" />
          </video>
        </vg-player>
      </div>
      } @else { @if (!documentLoading) {
      <div class="document-preview">
        <ngx-doc-viewer [url]="selectedReadFile" viewer="google" [googleCheckContentLoaded]="true"
          [googleCheckInterval]="3000" [googleMaxChecks]="5" style="width: 100%; height: 100%"
          (loaded)="contentLoaded()">
        </ngx-doc-viewer>
      </div>
      } }

      <!-- Document Viewer -->
    </section>

    <!-- Document Sidebar -->
    <aside class="document-list">
      <div class="sidebar-header">
        <div>
          <span class="sidebar-label"> DOCUMENTS </span>

          <h4>Available Files</h4>
        </div>

        <span class="document-count">
          {{ electedDocuments.length }}
        </span>
      </div>

      <div class="documents-scroll">
        @for (doc of electedDocuments; track doc; let i = $index) {
        <div class="document-item" [class.active]="i === selectedDocumentIndex" (click)="changeDocument(i)">
          <div class="file-icon">
            <i [ngClass]="{
                'pi pi-file-pdf': doc.file_type === 'pdf' || !doc.file_type,
                'pi pi-video': doc.file_type === 'video',
                'pi pi-volume-up': doc.file_type === 'audio',
                'pi pi-file':
                  doc.file_type !== 'pdf' &&
                  doc.file_type !== 'video' &&
                  doc.file_type !== 'audio'
              }">
            </i>
          </div>
          <div class="doc-info">
            <div class="doc-name">
              {{ doc.message }}
            </div>
            <span class="doc-number"> Document {{ i + 1 }} </span>
          </div>
          @if (i === selectedDocumentIndex) {
          <div class="selected-icon">
            <i class="pi pi-check"></i>
          </div>
          }
        </div>
        }

        <!-- Empty State -->
        @if (!electedDocuments?.length) {
        <div class="empty-documents">
          <i class="pi pi-folder-open"></i>
          <p>No documents available</p>
        </div>
        }
      </div>
    </aside>
  </div>

  <!-- Footer -->
  <ng-template pTemplate="footer">
    <div class="document-footer">
      <button pButton type="button" class="nav-btn" (click)="previousDocument()"
        [disabled]="selectedDocumentIndex === 0">
        <i class="pi pi-angle-left"></i>

        <span>Previous</span>
      </button>

      <div class="document-progress">
        <span class="current">
          {{ selectedDocumentIndex + 1 }}
        </span>

        <span class="separator">of</span>

        <span class="total">
          {{ electedDocuments.length }}
        </span>
      </div>

      <button pButton type="button" class="nav-btn" (click)="nextDocument()"
        [disabled]="selectedDocumentIndex === electedDocuments.length - 1">
        <span>Next</span>

        <i class="pi pi-angle-right"></i>
      </button>
    </div>
  </ng-template>
</p-dialog>

<!-- Voice Agent Popup -->
@if (showPopup) {
<div class="ai-agent-overlay" (click)="startAIVoiceAgent()">
  <div class="ai-agent-popup" [class.fullscreen]="fullscreen" (click)="$event.stopPropagation()">
    <!-- ================= Header ================= -->
    <div class="ai-popup-header">
      <div class="ai-agent-info">
        <img src="assets/images/AI_Voice_Agent_Icon.svg" class="logo" />
        <div>
          <h3>AI Voice Agent</h3>
          <span class="status" [ngClass]="statusClass">
            {{ status }}
          </span>
        </div>
      </div>
      <div class="actions">
        <button class="icon-btn" (click)="toggleFullscreen()">
          <i class="pi" [ngClass]="fullscreen ? 'pi-window-minimize' : 'pi-window-maximize'">
          </i>
        </button>
        <button class="icon-btn" (click)="startAIVoiceAgent()">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>
    <!-- ================= Body ================= -->
    <div class="ai-popup-body">
      <!-- Avatar -->
      @if (!showAvatar) {
      <div class="ai-avatar-section">
        <div class="ai-avatar-card" [class.listening]="avatarListening" [class.speaking]="avatarSpeaking">
          <!-- Idle -->
          @if (!avatarListening && !avatarSpeaking) {
          <img src="assets/images/ai_f_avatar.png" class="avatar-img" />
          }
          <!-- Listening -->
          @if (avatarListening) {
          <img src="assets/images/ai_f_avatar.png" class="avatar-img" />
          }
          <!-- Speaking -->
          @if (avatarSpeaking) {
          <img src="assets/images/ai_animate_avatar.gif" class="avatar-img" />
          }
        </div>
      </div>
      }
      <!-- Chat -->
      <div class="ai-chat-panel">
        <div class="ai-transcript-container" #transcriptContainer>
          @for (item of transcriptList; track item) {
          <div class="message" [class.user]="!item.isAgent" [class.agent]="item.isAgent">
            <!-- Bubble -->
            <div class="message-content">
              <div class="ai-message-heading">
                {{ item.isAgent ? "Agent" : "You" }}
              </div>
              <div class="ai-bubble">
                {{ item.text }}
                @if (!item.final) {
                <span class="typing">|</span>
                }
              </div>
            </div>
          </div>
          }
        </div>
        <!-- Text Input -->
        @if (connected) {
        <div class="ai-text-input">
          <input [(ngModel)]="userMessage" (keyup.enter)="sendMessage()" placeholder="Type a message..." />
          <button (click)="sendMessage()">
            <i class="pi pi-send"></i>
          </button>
        </div>
        }
      </div>
    </div>
    <!-- ================= Footer ================= -->
    <div class="ai-agent-footer">
      @if (connected) {
      <button class="circle-btn" [class.active]="!muted" (click)="toggleMute()">
        <i class="pi" [ngClass]="muted ? 'pi-microphone-slash' : 'pi-microphone'">
        </i>
      </button>
      } @if (connected) {
      <button class="circle-btn" [class.active]="showAvatar" (click)="toggleAvatar()">
        <i class="pi" [ngClass]="showAvatar ? 'pi-eye' : 'pi-eye-slash'"> </i>
        <!-- <img src="assets/images/ai_avatar.svg"> -->
      </button>
      }
      <button class="call-btn" [class.connected]="connected" [class.connecting]="connecting" [disabled]="connecting"
        (click)="toggleSession()">
        <i class="pi" [ngClass]="{
            'pi-spin pi-spinner': connecting,
            'pi-phone': connected && !connecting,
            'pi-play': !connected && !connecting
          }">
        </i>
        <span>
          {{
          connecting ? "Connecting..." : connected ? "Disconnect" : "Connect"
          }}
        </span>
      </button>
    </div>
  </div>
</div>
}
